import { authApi } from '../api'
import { BACKEND_URL_PREFIX } from '../assets/const';
import { setAuth, setLoading, clearAuth } from '../store/auth/slice'
import moment from 'moment'
import { buildDefaultHeaders } from './helper';


const TOKEN_UPDATING_INTERVAL = 190;

const getTimeToExpireToken = (getState) => {
  const { valid_until } = getState().auth;
  return moment(valid_until).diff(moment.utc()) / 1000 / 60;
};

export const checkAndUpdateToken = () => async (dispatch, getState) => {
  const timeToExpire = getTimeToExpireToken(getState);
  if (timeToExpire < TOKEN_UPDATING_INTERVAL) {
    try {
      const response = await fetch(
        `${BACKEND_URL_PREFIX}/token`,
        buildDefaultHeaders(getState)
        );
      if (response.ok) {
        const result = await response.json();
        if (result.error && result.error.code === 401) {
          dispatch(clearAuth())
        } else {
          dispatch(setAuth(result));
        }
      } else {
        dispatch(clearAuth())
      }
    } catch (ERR) {
      dispatch(clearAuth())
    }
  }
};

export const auth = (authString) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const token = window.btoa(unescape(encodeURIComponent(authString)));
    const Authorization = `Basic ${token}`;
    const response = await authApi.login(Authorization)
    dispatch(setAuth(response.data))
  } catch (error) {
    console.log(error)
  } finally {
    dispatch(setLoading(false))
  }
}